import gsap from 'gsap'
import { ScrambleTextPlugin } from 'gsap/ScrambleTextPlugin'
import { debounce } from './utilities'

gsap.registerPlugin(ScrambleTextPlugin) 

export const initScrambleText = () => {

	const chars = 'abcdefghijklmnopqrstuvwxyz'
	const links = document.querySelectorAll('.menu-item a')

	const scramble = (event) => {
		const target = event.target
		 if (!gsap.isTweening(target) && window.matchMedia('(prefers-reduced-motion: no-preference)').matches) {
			gsap.to(target, {
				duration: 0.4,
				ease: 'sine.in',
				scrambleText: {
					text: target.innerText,
					speed: 1,
					chars: chars
				}
			})
		}
	}
	
	for (const link of links) {
		link.style.width = link.offsetWidth + 'px'
		link.addEventListener('pointerenter', scramble)
		link.addEventListener('focus', scramble)
	}

	let windowWidth = window.innerWidth

	const handleResize = () => {
		if (windowWidth != window.innerWidth) {
			console.log('resize')
			for (const link of links) {
				link.style.width = ''
				link.style.width = link.offsetWidth + 'px'
			}
			windowWidth = window.innerWidth
		}
	}

	const debouncedResize = debounce(handleResize, 300)
	window.addEventListener('resize', debouncedResize)
}

export default () => {}